  // function galshow(){
		// 	document.getElementById('galbox').style.display="block";
		// }
		// function galhide(){
		// 	document.getElementById('galbox').style.display="none";
		// }
$('.galimage').click(function() {
  var th = $(this);
  var thissrc = th.attr("src");
  th.parents('.container_gallery').find('.gallery_pop img').attr("src", thissrc);
  var para = th.parents('.gal_table').find('.popup_paragraph').text();
  th.parents('.container_gallery').find('.gallery_pop p').text(para);
  $('#galbox').show();
});
$('.galclose').click(function() {
  $('#galbox').hide();
})